import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/scheduleApplicationActions'
import * as api from '../../api/job/scheduleApplications'

function* getScheduleApplicationDates(action) {
  try {
    const payload = yield call(api.getScheduleApplicationDates, action.jobId)
    yield put({ type: constants.GET_SCHEDULE_APPLICATION_DATES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_SCHEDULE_APPLICATION_DATES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetScheduleApplicationDates() {
  yield takeLatest(constants.GET_SCHEDULE_APPLICATION_DATES.ACTION, getScheduleApplicationDates)
}

function* sagaAddScheduleApplicationDate(action) {
  try {
    const payload = {
      job_id: action.jobId,
      schedule_id: action.scheduleId,
      updated_by_id: action.userId,
      created_by_id: action.userId,
      user_id: action.userId
    }

    yield call(api.addScheduleApplicationDates, payload)
    yield put({ type: constants.ADD_SCHEDULE_APPLICATION_DATE.SUCCESS, payload })
    yield call(getScheduleApplicationDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.ADD_SCHEDULE_APPLICATION_DATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddScheduleApplicationDate() {
  yield takeLatest(constants.ADD_SCHEDULE_APPLICATION_DATE.ACTION, sagaAddScheduleApplicationDate)
}

function* sagaUpdateScheduleApplicationDates(action) {
  try {
    const payload = {
      job_id: action.jobId,
      schedule_id: action.scheduleId,
      content: action.content,
      updated_by_id: action.userId,
      type: action.scheduleType,
      description: action.description,
      due_date: action.content[action.scheduleType],
      assigned_to_id: 1,
      user_id: 1
    }

    yield call(api.updateScheduleApplicationDates, payload)
    yield put({ type: constants.SCHEDULE_APPLICATION_UPDATE.SUCCESS, payload })
    yield call(getScheduleApplicationDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_APPLICATION_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleApplication() {
  yield takeLatest(constants.SCHEDULE_APPLICATION_UPDATE.ACTION, sagaUpdateScheduleApplicationDates)
}

function* sagaDeleteScheduleApplication(action) {
  try {
    const payload = {
      schedule_id: action.scheduleId
    }
    yield call(api.deleteScheduleApplication, payload)
    yield put({ type: constants.DELETE_SCHEDULE_APPLICATION.SUCCESS, payload })
    yield call(getScheduleApplicationDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_SCHEDULE_APPLICATION.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteScheduleApplication() {
  yield takeLatest(constants.DELETE_SCHEDULE_APPLICATION.ACTION, sagaDeleteScheduleApplication)
}

function* sagaUpdateScheduleApplicationNotes(action) {
  try {
    const payload = {
      job_id: action.jobId,
      schedule_id: action.scheduleId,
      notes: action.notes,
      updated_by_id: action.userId,
      user_id: 1
    }
    yield call(api.updateScheduleApplicationNotes, payload)
    yield put({ type: constants.SCHEDULE_APPLICATION_UPDATE_NOTE.SUCCESS, payload })
    yield call(getScheduleApplicationDates, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULE_APPLICATION_UPDATE_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateScheduleApplicationNotes() {
  yield takeLatest(
    constants.SCHEDULE_APPLICATION_UPDATE_NOTE.ACTION,
    sagaUpdateScheduleApplicationNotes
  )
}

export function* rootSaga() {
  yield all([
    fork(watchGetScheduleApplicationDates),
    fork(watchUpdateScheduleApplication),
    fork(watchUpdateScheduleApplicationNotes),

    fork(watchAddScheduleApplicationDate),
    fork(watchDeleteScheduleApplication)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/scheduleApplicationSaga.js